import { useState, useEffect } from 'react';
import dynamic from 'next/dynamic';
import noImage from '@/assets/webp/no-image.webp';

const ReactPhotoSphereViewer = dynamic(
  () => import('react-photo-sphere-viewer').then((m) => m.ReactPhotoSphereViewer),
  { ssr: false },
);
import { Loader } from '@/components';
import NextImage from 'next/image';
import { SafePhotoSphereBox } from './styled';

type Props = {
  src: string;
  minHeight?: number;
};

function checkIfImageExists(url: string): Promise<boolean> {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = url;

    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
  });
}

export const SafePhotoSphereViewer = ({ src, minHeight = 500 }: Props) => {
  const [imageExists, setImageExists] = useState<boolean | null>(null);

  useEffect(() => {
    if (!src) {
      queueMicrotask(() => {
        setImageExists(false);
      });
      return;
    }
    void checkIfImageExists(src).then(setImageExists);
  }, [src]);

  if (imageExists === null) {
    return (
      <SafePhotoSphereBox>
        <Loader />
      </SafePhotoSphereBox>
    );
  }

  if (!imageExists) {
    return (
      <SafePhotoSphereBox>
        <NextImage
          src={noImage}
          width={1200}
          height={400}
          alt="No 360° preview"
          style={{ maxHeight: minHeight, objectFit: 'contain' }}
        />
      </SafePhotoSphereBox>
    );
  }

  return <ReactPhotoSphereViewer src={src} height={`${minHeight}px`} width="100%" />;
};
